<template>
    <BaseDialog
        :showDialog="showDialog"
        headline="Release Validation Errors"
        :close="close"
        persistent
        :alvqa="alvqa"
    >
        <template v-slot:dialogText>
            <v-container>
                <v-row>
                    <v-col>
                        Validation Errors:
                        <!-- {{ validationErrorDetails }} -->
                    </v-col>
                </v-row>
            </v-container>
        </template>
    </BaseDialog>
</template>

<script>
import BaseDialog from '@/components/_base/BaseDialog'

export default {
    name: "LabelReleasesValidationErrorDialog",
    components: {
        BaseDialog
    },
    data() {
        return {
            alvqa: 'label-releases-list-dialog-validation-errors',
        }
    },
    computed: {
        showDialog: {
            get() { return this.$store.getters.getShowLabelReleaseValidationErrorDialog },
            set(show) { this.$store.commit('setShowLabelReleaseValidationErrorDialog', show) }
        }
    },
    methods: {
        close() {
            this.showDialog = false
        }
    }
}

</script>